mapboxgl.accessToken = 'pk.eyJ1Ijoib2xzZW5ldXJvcGUiLCJhIjoiY2xjamRncHB3MDY5cDN2cW9rYjNjNTM2ZiJ9.VGL4lPNqnuzFv_zJ9RSgqg';

/**
 * Add the map to the page
 */

const config = {
 CSV: 'https://cdn.shopify.com/s/files/1/0260/1641/5819/files/Sample_Data.csv?v=1673985048',
  filters: [
    {
      type: 'dropdown',
      title: 'Languages supported: ',
      columnHeader: 'Languages',
      listItems: [
        'Amharic',
        'ASL',
        'Cambodian',
        'Chinese',
        'Danish',
        'English',
        'French',
        'German',
        'Greek',
        'Hindi',
        'Italian',
        'Japanese',
        'Korean',
        'Language Line Services',
        'Norwegian',
        'Oriya',
        'Portuguese',
        'Punjabi',
        'Russian',
        'Somali',
        'Spanish',
        'Swedish',
        'Tagalog',
        'Thai',
        'Tigrinya',
        'Tongan',
        'Vietnamese',
        'Ukranian',
      ],
    },
    {
      type: 'checkbox',
      title: 'Devices available: ',
      columnHeader: 'Devices_available', // Case sensitive - must match spreadsheet entry
      listItems: ['Computer', 'Wi-Fi', 'Adaptive Laptops'], // Case sensitive - must match spreadsheet entry; This will take up to six inputs but is best used with a maximum of three;
    },
    {
      type: 'dropdown',
      title: 'Clients: ',
      columnHeader: 'Clients',
      listItems: [
        'Adults',
        'Disabled',
        'Homeless',
        'Immigrants/Refugees',
        'Low Income',
        'Seniors',
        'Youth: Pre-teen',
        'Youth: Teen',
      ],
    },
  ],
};
  
const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v11',
  center: [-79.5924498,43.6184516],
  zoom: 8,
  scrollZoom: true
});

const stores = {
  'type': 'FeatureCollection',
  'features': [
    {
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
43.0989798,
-78.9807416
]},
'properties': {
"phoneFormatted": " ",
"name": "Niagara Outlet",
"phone": "",
"address": "1900 Military Road",
"city": "Niagara Falls",
"state": "NY",
"postalCode": "14304",
"country": "US"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.117189,
49.282443
]},
'properties': {
"phoneFormatted": "(604) 681-6211 ext 6263",
"name": "Vancouver Downtown - Store located within Hudson's Bay",
"phone": "(604) 681-6211 ext 6263",
"address": "674 Granville Street",
"city": "Vancouver",
"state": "British Columbia",
"postalCode": "V6C 1Z6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-97.197081,
49.881605
]},
'properties': {
"phoneFormatted": "(204) 975-3228 ext 355",
"name": "Polo Park - Store located within Hudson's Bay",
"phone": "(204) 975-3228 ext 355",
"address": "1485 Portage Avenue",
"city": "Winnipeg",
"state": "Manitoba",
"postalCode": "R3G 0W4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.556481,
43.63241
]},
'properties': {
"phoneFormatted": "(416)231-5551",
"name": "Cloverdale Mall (Outlet)",
"phone": "(416)231-5551",
"address": "250 The East Mall",
"city": "Etobicoke",
"state": "Ontario",
"postalCode": "M9B 3Y8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.138407,
49.167139
]},
'properties': {
"phoneFormatted": "(604)233-0580",
"name": "CF Richmond Centre - Store located within Hudson's Bay",
"phone": "(604)233-0580",
"address": "Richmond Centre, Ste. 100 6060 Minoru Boulevard",
"city": "Richmond",
"state": "British Columbia",
"postalCode": "V6Y 1Y2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.786797,
49.048735
]},
'properties': {
"phoneFormatted": "(604) 538-2466",
"name": "The Shops at Morgan Crossing",
"phone": "(604) 538-2466",
"address": "15715 Croydon Drive, Unit AB 108",
"city": "Surrey",
"state": "British Columbia",
"postalCode": "V3S 2L5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-97.114009,
49.829294
]},
'properties': {
"phoneFormatted": "(204) 255-1227 x2403",
"name": "St. Vital Centre - Store located within Hudson's Bay",
"phone": "(204) 255-1227 x2403",
"address": "1225 St. Mary's Road",
"city": "Winnipeg",
"state": "Manitoba",
"postalCode": "R2M 5E5",
"country": "Canada"
}},
         {
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.674191,
49.114663
]},
'properties': {
"phoneFormatted": "(604) 530-8434 ext 261",
"name": "Willowbrook Shopping Centre - Store located within Hudson's Bay",
"phone": "(604) 530-8434 ext 261",
"address": "19705 Fraser Highway",
"city": "Langley",
"state": "British Columbia",
"postalCode": "V3A 7E9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-106.667625,
52.127516
]},
'properties': {
"phoneFormatted": "(306) 242-7611 x267",
"name": "Midtown Plaza - Store located within Hudson's Bay",
"phone": "(306) 242-7611 x267",
"address": "201 First Avenue South",
"city": "Saskatoon",
"state": "Saskatchewan",
"postalCode": "S7K 3M1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-114.066143,
51.046049
]},
'properties': {
"phoneFormatted": "(403) 263-9791 ext. 3362",
"name": "Calgary Downtown - Store located within Hudson's Bay",
"phone": "(403) 263-9791 ext. 3362",
"address": "200-8th Avenue S.W.",
"city": "Calgary",
"state": "Alberta",
"postalCode": "T2P 1B5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.995751,
49.22604
]},
'properties': {
"phoneFormatted": "(604) 436-1664",
"name": "Metropolis at Metrotown - Store located within Hudson's Bay",
"phone": "(604) 436-1664",
"address": "4850 Kingsway",
"city": "Burnaby",
"state": "British Columbia",
"postalCode": "V5H 4P2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-114.074005,
50.997882
]},
'properties': {
"phoneFormatted": "(403) 255-6534  ext 356",
"name": "Chinook Centre - Store located within Hudson's Bay",
"phone": "(403) 255-6534  ext 356",
"address": "6455 MacLeod Trail S.W.",
"city": "Calgary",
"state": "Alberta",
"postalCode": "T2H 0K9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-124.048358,
49.236144
]},
'properties': {
"phoneFormatted": "(250) 390-3141 ext 358",
"name": "Woodgrove Centre - Store located within Hudson's Bay",
"phone": "(250) 390-3141 ext 358",
"address": "Hudson Bay Company 6631 Island Highway North",
"city": "Nanaimo",
"state": "British Columbia",
"postalCode": "V9T 4V7",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-113.617833,
53.522266
]},
'properties': {
"phoneFormatted": "(780) 444-5110",
"name": "West Edmonton Mall - Store located within Hudson's Bay",
"phone": "(780) 444-5110",
"address": "Hudson's Bay, 8882 170 St. NW",
"city": "Edmonton",
"state": "Alberta",
"postalCode": "T5T 4J2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-110.643823,
50.003675
]},
'properties': {
"phoneFormatted": "(403) 525-9300",
"name": "Medicine Hat Mall  - Store located within Hudson's Bay",
"phone": "(403) 525-9300",
"address": "3292 Dunmore Rd SE",
"city": "Medicine Hat",
"state": "Alberta",
"postalCode": "T1B 2R4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.751469,
45.568132
]},
'properties': {
"phoneFormatted": "(450) 687-1540 ext 261",
"name": "CF Carrefour Laval - Store located within Hudson's Bay",
"phone": "(450) 687-1540 ext 261",
"address": "3045 Boulevard Le Carrefour",
"city": "Laval",
"state": "Quebec",
"postalCode": "H7T 1C7",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.886155,
49.133388
]},
'properties': {
"phoneFormatted": "(604) 588-2111 ext 236",
"name": "Guildford Town Centre - Store located within Hudson's Bay",
"phone": "(604) 588-2111 ext 236",
"address": "1400 Guildford Town Centre",
"city": "Surrey",
"state": "British Columbia",
"postalCode": "V3W 2L9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.8004,
49.278722
]},
'properties': {
"phoneFormatted": "(778) 941-4110",
"name": "Coquitlam Centre - Store located within Hudson's Bay",
"phone": "(778) 941-4110",
"address": "100  2929 Barnet Highway",
"city": "Coquitlam",
"state": "British Columbia",
"postalCode": "V3B 5R5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-113.984562,
51.075244
]},
'properties': {
"phoneFormatted": "(403) 232-1169 x478",
"name": "Sunridge Mall (Outlet)  - Store located within Hudson's Bay",
"phone": "(403) 232-1169 x478",
"address": "Hudson's Bay, 2525 36th St. NE",
"city": "Calgary",
"state": "Alberta",
"postalCode": "T1Y 5T4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.422234,
43.795745
]},
'properties': {
"phoneFormatted": "(416) 225-9766",
"name": "Centerpoint Mall (Outlet) - Store located within Hudson's Bay",
"phone": "(416) 225-9766",
"address": "6464 Yonge Street",
"city": "North York",
"state": "Ontario",
"postalCode": "M2M 3X4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-114.066257,
50.952554
]},
'properties': {
"phoneFormatted": "(403) 278-9520 ext 375",
"name": "Southcentre Mall - Store located within Hudson's Bay",
"phone": "(403) 278-9520 ext 375",
"address": "100 Anderson Road S.E.",
"city": "Calgary",
"state": "Alberta",
"postalCode": "T2J 3V1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.344091,
43.77799
]},
'properties': {
"phoneFormatted": "(416) 491-2010 ext 227",
"name": "Fairview Mall - Store located within Hudson's Bay",
"phone": "(416) 491-2010 ext 227",
"address": "1800 Sheppard Ave. East",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M2J 5A7",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.643175,
43.592728
]},
'properties': {
"phoneFormatted": "(905) 270-7600 ext 357",
"name": "Square One Shopping Centre - Store located within Hudson's Bay",
"phone": "(905) 270-7600 ext 357",
"address": "100 City Centre Drive",
"city": "Mississauga",
"state": "Ontario",
"postalCode": "L5B 2C9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-113.508499,
53.564194
]},
'properties': {
"phoneFormatted": "(780) 474-3575",
"name": "Kingsway Mall - Store located within Hudson's Bay",
"phone": "(780) 474-3575",
"address": "109th Street & Princess Elizabeth Ave",
"city": "Edmonton",
"state": "Alberta",
"postalCode": "T5G 3A6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.598864,
43.719375
]},
'properties': {
"phoneFormatted": "(416) 679-9606",
"name": "Woodbine Centre  (Outlet) - Store located within Hudson's Bay",
"phone": "(416) 679-9606",
"address": "c/o Hudson's Bay. 500 Rexdale Blvd.",
"city": "Etobicoke",
"state": "Ontario",
"postalCode": "M9W 6K5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.485504,
44.056104
]},
'properties': {
"phoneFormatted": "(905) 836-8723",
"name": "Upper Canada Mall - Store located within Hudson's Bay",
"phone": "(905) 836-8723",
"address": "17600 Yonge Street North",
"city": "Newmarket",
"state": "Ontario",
"postalCode": "L3Y 4Z1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.792752,
43.348797
]},
'properties': {
"phoneFormatted": "(905) 319-2820",
"name": "Burlington Centre",
"phone": "(905) 319-2820",
"address": "777 Guelph Line",
"city": "Burlington",
"state": "Ontario",
"postalCode": "L7R 3N2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-78.88099,
43.891998
]},
'properties': {
"phoneFormatted": "(905) 579-3018",
"name": "Oshawa Centre - Store located within Hudson's Bay",
"phone": "(905) 579-3018",
"address": "Oshawa Shopping Centre,  419 King Street W",
"city": "Oshawa",
"state": "Ontario",
"postalCode": "L1J 2K5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.686869,
43.461607
]},
'properties': {
"phoneFormatted": "(905) 842-4811",
"name": "Oakville Place - Store located within Hudson's Bay",
"phone": "(905) 842-4811",
"address": "240 Leighland Avenue",
"city": "Oakville",
"state": "Ontario",
"postalCode": "L6H 3H6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.287043,
43.869539
]},
'properties': {
"phoneFormatted": "(905) 513-1770 ext 316",
"name": "Markville Shopping Centre - Store located within Hudson's Bay",
"phone": "(905) 513-1770 ext 316",
"address": "5000 Highway 7",
"city": "Markham",
"state": "Ontario",
"postalCode": "L3R 4M9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-81.224689,
42.931587
]},
'properties': {
"phoneFormatted": "(519) 668-6997",
"name": "White Oaks Mall - Store located within Hudson's Bay",
"phone": "(519) 668-6997",
"address": "1105 Wellington Road South",
"city": "London",
"state": "Ontario",
"postalCode": "N6A 1V4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-80.441181,
43.424446
]},
'properties': {
"phoneFormatted": "(519) 894-1111 ext. 477",
"name": "CF Fairview Park - Store located within Hudson's Bay",
"phone": "(519) 894-1111 ext. 477",
"address": "3050 Kingsway Drive",
"city": "Kitchener",
"state": "Ontario",
"postalCode": "N2C 2J7",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.436539,
43.854855
]},
'properties': {
"phoneFormatted": "(905) 883-1222 ext. 280",
"name": "Hillcrest Mall  - Store located within Hudson's Bay",
"phone": "(905) 883-1222 ext. 280",
"address": "9350 Yonge Street",
"city": "Richmond Hill",
"state": "Ontario",
"postalCode": "L4C 5G2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.818819,
43.324485
]},
'properties': {
"phoneFormatted": "(905) 681-0030 ext. 308",
"name": "Mapleview  - Store located within Hudson's Bay",
"phone": "(905) 681-0030 ext. 308",
"address": "900 Maple Ave",
"city": "Burlington",
"state": "Ontario",
"postalCode": "L7S 2J8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.257576,
43.776035
]},
'properties': {
"phoneFormatted": "(416) 296-9981 x400",
"name": "Scarborough Town Centre - Store located within Hudson's Bay",
"phone": "(416) 296-9981 x400",
"address": "300 Borough Drive",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M1P 4P5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.380169,
43.651791
]},
'properties': {
"phoneFormatted": "(416) 861-6744",
"name": "Queen Street - Store located within Hudson's Bay",
"phone": "(416) 861-6744",
"address": "176 Yonge Street",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M5C 2L7",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.556832,
43.611364
]},
'properties': {
"phoneFormatted": "(416) 626-4711 ext 426",
"name": "Sherway Gardens - Store located within Hudson's Bay",
"phone": "(416) 626-4711 ext 426",
"address": "25 The Prairies Mall",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M9C 1B8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-80.529563,
43.499103
]},
'properties': {
"phoneFormatted": "(519) 884-6990  ext: 362",
"name": "Conestoga Mall - Store located within Hudson's Bay",
"phone": "(519) 884-6990  ext: 362",
"address": "550 King Street North",
"city": "Waterloo",
"state": "Ontario",
"postalCode": "N2L 5W6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.861533,
43.217624
]},
'properties': {
"phoneFormatted": "(905) 318-8008 ext. 504",
"name": "Lime Ridge Mall - Store located within Hudson's Bay",
"phone": "(905) 318-8008 ext. 504",
"address": "999 Upper Wentworth St.",
"city": "Hamilton",
"state": "Ontario",
"postalCode": "L9A 4X5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.378175,
45.503852
]},
'properties': {
"phoneFormatted": "(450)653-4455 ext. 478",
"name": "CF Promenades St. Bruno - Store located within Hudson's Bay",
"phone": "(450)653-4455 ext. 478",
"address": "800 boul. des Promeandes",
"city": "St. Bruno",
"state": "Quebec",
"postalCode": "J3V 5J9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.222787,
43.13471
]},
'properties': {
"phoneFormatted": "(905) 688-4441 ext. 357",
"name": "The Pen Centre - Store located within Hudson's Bay",
"phone": "(905) 688-4441 ext. 357",
"address": "221 Glendale Avenue",
"city": "St. Catharines",
"state": "Ontario",
"postalCode": "L2T 2K9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.648972,
45.52779
]},
'properties': {
"phoneFormatted": "(514) 344-4707",
"name": "Rockland Centre - Store located within Hudson's Bay",
"phone": "(514) 344-4707",
"address": "2435 Chemin Rockland",
"city": "Ville Mont-Royal",
"state": "Quebec",
"postalCode": "H3P 2Z3",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.829689,
45.464636
]},
'properties': {
"phoneFormatted": "(514) 697-5213",
"name": "Fairview Pointe Claire - Store located within Hudson's Bay",
"phone": "(514) 697-5213",
"address": "6790 Route Trans Canada",
"city": "Pointe Claire",
"state": "Quebec",
"postalCode": "H9R 1C5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.569262,
45.504123
]},
'properties': {
"phoneFormatted": "(514) 281-4880",
"name": "Montreal Downtown - Store located within Hudson's Bay",
"phone": "(514) 281-4880",
"address": "585 St. Catherine St. W.",
"city": "Montreal",
"state": "Quebec",
"postalCode": "H3B 3Y5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-75.692666,
45.426215
]},
'properties': {
"phoneFormatted": "(613) 244-8555",
"name": "Rideau Centre - Store located within Hudson's Bay",
"phone": "(613) 244-8555",
"address": "73 Rideau Street",
"city": "Ottawa",
"state": "Ontario",
"postalCode": "K1N 5W8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-75.638706,
45.421947
]},
'properties': {
"phoneFormatted": "(613) 746-0517",
"name": "St. Laurent Centre - Store located within Hudson's Bay",
"phone": "(613) 746-0517",
"address": "1200 St. Laurent Boul",
"city": "Ottawa",
"state": "Ontario",
"postalCode": "K1K 3B8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-75.697285,
45.475653
]},
'properties': {
"phoneFormatted": "(819) 243-6161",
"name": "Les Promenade Gatineau - Store located within Hudson's Bay",
"phone": "(819) 243-6161",
"address": "1100 boul. Maloney O.",
"city": "Gatineau",
"state": "Quebec",
"postalCode": "J8T 6G3",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-75.515557,
45.47817
]},
'properties': {
"phoneFormatted": "(613) 837-5170",
"name": "Place D'Orleans - Store located within Hudson's Bay",
"phone": "(613) 837-5170",
"address": "110 Place d'Orleans Drive",
"city": "Orleans",
"state": "Ontario",
"postalCode": "K1C 2L9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-71.299343,
46.830726
]},
'properties': {
"phoneFormatted": "(418) 627-3536",
"name": "Les Galeries de la Capitale - Store located within Hudson's Bay",
"phone": "(418) 627-3536",
"address": "5401 boulevard des Galeries",
"city": "Quebec",
"state": "Quebec",
"postalCode": "G2K 1N4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-75.806832,
45.347237
]},
'properties': {
"phoneFormatted": "(613) 596-9810 ext 4838",
"name": "Bayshore Shopping Centre - Store located within Hudson's Bay",
"phone": "(613) 596-9810 ext 4838",
"address": "100 Bayshore Dr.",
"city": "Ottawa",
"state": "Ontario",
"postalCode": "K2B 8C1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.471822,
45.472855
]},
'properties': {
"phoneFormatted": "(450) 671-0908",
"name": "Mail Champlain - Store located within Hudson's Bay",
"phone": "(450) 671-0908",
"address": "2151 Boulevard LapiniÃ¨re",
"city": "Brossard",
"state": "Quebec",
"postalCode": "J4W 2T5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.818603,
45.630808
]},
'properties': {
"phoneFormatted": "(450) 420-0406",
"name": "Place Rosemere - Store located within Hudson's Bay",
"phone": "(450) 420-0406",
"address": "401 boul. Labelle",
"city": "Rosemere",
"state": "Quebec",
"postalCode": "J7A 3T2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-60.136929,
46.146852
]},
'properties': {
"phoneFormatted": "(902) 562-9815",
"name": "Mayflower Mall - Store located within Hudson's Bay",
"phone": "(902) 562-9815",
"address": "Mayflower Mall, 800 Grand Lake Road",
"city": "Sydney",
"state": "Nova Scotia",
"postalCode": "B1P 6S9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.369536,
48.446984
]},
'properties': {
"phoneFormatted": "(250) 920-7902",
"name": "Mayfair Shopping Centre",
"phone": "(250) 920-7902",
"address": "3147 Douglas Street Unit 359",
"city": "Victoria",
"state": "British Columbia",
"postalCode": "V8Z 6E3",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-63.559447,
44.686346
]},
'properties': {
"phoneFormatted": "(902) 469-6680 ext 504",
"name": "Mic Mac Mall - Store located within Hudson's Bay",
"phone": "(902) 469-6680 ext 504",
"address": "21 Mic Mac Blvd",
"city": "Dartmouth",
"state": "Nova Scotia",
"postalCode": "B3A 4N3",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.613021,
45.445285
]},
'properties': {
"phoneFormatted": "(514) 366-0825  ext. 395",
"name": "Carrefour Angrignon - Store located within Hudson's Bay",
"phone": "(514) 366-0825  ext. 395",
"address": "7091 Newman Boulevard",
"city": "LaSalle",
"state": "Quebec",
"postalCode": "H8N 1X1",
"country": "Canada"
}},
    {
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.386712,
43.768518
]},
'properties': {
"phoneFormatted": "(416) 229-6474",
"name": "Bayview Village",
"phone": "(416) 229-6474",
"address": "2901 Bayview Avenue, Unit 39",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M2K 1E6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.135832,
49.327522
]},
'properties': {
"phoneFormatted": "(604) 922-2029",
"name": "Park Royal Shopping Centre",
"phone": "(604) 922-2029",
"address": "743 Park Royal N",
"city": "West Vancouver",
"state": "British Columbia",
"postalCode": "V7T 1H9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-71.279835,
46.77213
]},
'properties': {
"phoneFormatted": "(418) 780-3038",
"name": "Place Ste-Foy",
"phone": "(418) 780-3038",
"address": "2450 Blvd Laurier, Unit #127A",
"city": "Quebec",
"state": "Quebec",
"postalCode": "G1V 2L1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.13582,
49.327608
]},
'properties': {
"phoneFormatted": "(604) 925-1461",
"name": "Park Royal Shopping Centre - Store located within Hudson's Bay",
"phone": "(604) 925-1461",
"address": "725 Park Royal North",
"city": "West Vancouver",
"state": "British Columbia",
"postalCode": "V7T 1H9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-63.578548,
44.642951
]},
'properties': {
"phoneFormatted": "(902) 423-0516",
"name": "Park Lane Mall (Outlet)",
"phone": "(902) 423-0516",
"address": "5657 Spring Garden Road, Box 183",
"city": "Halifax",
"state": "Nova Scotia",
"postalCode": "B3J 3R4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-81.277929,
43.026148
]},
'properties': {
"phoneFormatted": "(519) 667-0096",
"name": "Masonville Place",
"phone": "(519) 667-0096",
"address": "1680 Richmond St. N Unit U069",
"city": "London",
"state": "Ontario",
"postalCode": "N6G 3Y9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.345007,
43.735518
]},
'properties': {
"phoneFormatted": "(416) 384-0876",
"name": "Shops at Don Mills",
"phone": "(416) 384-0876",
"address": "24 Karl Fraser Rd,  Unit J006B",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M3C 0G5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.452459,
43.80648
]},
'properties': {
"phoneFormatted": "(905) 882-0121",
"name": "Promenade",
"phone": "(905) 882-0121",
"address": "1 Promenade Circle, Unit #B208",
"city": "Thornhill",
"state": "Ontario",
"postalCode": "L4J 4P8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-113.515496,
53.48615
]},
'properties': {
"phoneFormatted": "(780) 439-9399",
"name": "Southgate Centre",
"phone": "(780) 439-9399",
"address": "#51 - 5015 - 111 St. NW",
"city": "Edmonton",
"state": "Alberta",
"postalCode": "T6H 4M6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-63.618185,
44.649303
]},
'properties': {
"phoneFormatted": "(902) 487-2846",
"name": "Halifax Shopping Centre",
"phone": "(902) 487-2846",
"address": "7001 Mumford Road, unit 247",
"city": "Halifax",
"state": "Nova Scotia",
"postalCode": "B3L 2H8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-52.754311,
47.561011
]},
'properties': {
"phoneFormatted": "(709)722-7748",
"name": "Avalon Mall",
"phone": "(709)722-7748",
"address": "48 Kenmount Road, unit 2030",
"city": "St. John's",
"state": "Newfoundland",
"postalCode": "A1B 1W3",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-114.154918,
51.084709
]},
'properties': {
"phoneFormatted": "(403) 286-1220  ext: 354",
"name": "Market Mall - Store located within Hudson's Bay",
"phone": "(403) 286-1220  ext: 354",
"address": "3625 Shaganappi Trail NW",
"city": "Calgary",
"state": "Alberta",
"postalCode": "T3A 0E2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-113.813564,
52.244962
]},
'properties': {
"phoneFormatted": "(403) 347-2211  ext: 266",
"name": "Bower Place Mall - Store located within Hudson's Bay",
"phone": "(403) 347-2211  ext: 266",
"address": "4900 Molly Bannister Drive",
"city": "Red Deer",
"state": "Alberta",
"postalCode": "T4R 1N9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.452809,
43.725108
]},
'properties': {
"phoneFormatted": "(416) 789-8011  ext: 7115",
"name": "Yorkdale - Store located within Hudson's Bay",
"phone": "(416) 789-8011  ext: 7115",
"address": "3401 Dufferin Street",
"city": "Toronto",
"state": "Ontario",
"postalCode": "M6A 2T9",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-122.310478,
49.050524
]},
'properties': {
"phoneFormatted": "(604) 853-7711  ext: 258",
"name": "Sevenoaks Shopping Centre - Store located within Hudson's Bay",
"phone": "(604) 853-7711  ext: 258",
"address": "32900 South Fraser Way",
"city": "Abbotsford",
"state": "British Columbia",
"postalCode": "V2S 5A1",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.088292,
43.834004
]},
'properties': {
"phoneFormatted": "(905) 837-8691  ext: 387",
"name": "Pickering Town Centre - Store located within Hudson's Bay",
"phone": "(905) 837-8691  ext: 387",
"address": "1355 Kingston Road",
"city": "Pickering",
"state": "Ontario",
"postalCode": "L1V 1B8",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-76.572171,
44.256336
]},
'properties': {
"phoneFormatted": "(613) 384-3888  ext: 240",
"name": "Cataraqui Centre - Store located within Hudson's Bay",
"phone": "(613) 384-3888  ext: 240",
"address": "945 Gardiners Road",
"city": "Kingston",
"state": "Ontario",
"postalCode": "K7M 7H4",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-73.56681,
45.600605
]},
'properties': {
"phoneFormatted": "(514) 353-3300  ext: 216",
"name": "Galeries d'Anjou - Store located within Hudson's Bay",
"phone": "(514) 353-3300  ext: 216",
"address": "7895 Boulevard des Galeries d'Anjou",
"city": "Ville d'Anjou",
"state": "Quebec",
"postalCode": "H1M 1W6",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-79.711591,
43.558645
]},
'properties': {
"phoneFormatted": "(905) 820-83  ext: 1375",
"name": "Erin Mills Town Centre - Store located within Hudson's Bay",
"phone": "(905) 820-83  ext: 1375",
"address": "5100 Erin Mills Parkway",
"city": "Mississauga",
"state": "Ontario",
"postalCode": "L5M 4Z5",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-119.44003,
49.880243
]},
'properties': {
"phoneFormatted": "(250) 860-2483  ext 237",
"name": "Orchard Park Shopping Centre - Store located within Hudson's Bay",
"phone": "(250) 860-2483  ext 237",
"address": "2271 Harvey Ave",
"city": "Kelowna",
"state": "British Columbia",
"postalCode": "V1Y 6H2",
"country": "Canada"
}},
{
'type': 'Feature',
'geometry': {
'type': 'Point',
"coordinates": [
-123.366785,
48.425344
]},
'properties': {
"phoneFormatted": "(250) 361-3070",
"name": "The Bay Centre - Store located within Hudson's Bay",
"phone": "(250) 361-3070",
"address": "1150 Douglas Street",
"city": "Victoria",
"state": "British Columbia",
"postalCode": "V8Z 2C8",
"country": "Canada"
}}
  ]
};

/**
 * Assign a unique id to each store. You'll use this `id`
 * later to associate each point on the map with a listing
 * in the sidebar.
 */
stores.features.forEach((store, i) => {
  store.properties.id = i;
});

/**
 * Wait until the map loads to make changes to the map.
 */
map.on('load', () => {
  /**
   * This is where your '.addLayer()' used to be, instead
   * add only the source without styling a layer
   */
  map.addSource('places', {
    'type': 'geojson',
    'data': stores
  });

  /**
   * Create a new MapboxGeocoder instance.
   */
  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    marker: true,
    bbox: [-140.99778, 41.6751050889, -52.6480987209, 83.23324]
  });

  /**
   * Add all the things to the page:
   * - The location listings on the side of the page
   * - The search box (MapboxGeocoder) onto the map
   * - The markers onto the map
   */
  buildLocationList(stores);
  map.addControl(geocoder, 'top-left');
  addMarkers();

  /**
   * Listen for when a geocoder result is returned. When one is returned:
   * - Calculate distances
   * - Sort stores by distance
   * - Rebuild the listings
   * - Adjust the map camera
   * - Open a popup for the closest store
   * - Highlight the listing for the closest store.
   */
  geocoder.on('result', (event) => {
    /* Get the coordinate of the search result */
    const searchResult = event.result.geometry;

    /**
     * Calculate distances:
     * For each store, use turf.disance to calculate the distance
     * in miles between the searchResult and the store. Assign the
     * calculated value to a property called `distance`.
     */
    const options = { units: 'miles' };
    for (const store of stores.features) {
      store.properties.distance = turf.distance(
        searchResult,
        store.geometry,
        options
      );
    }

    /**
     * Sort stores by distance from closest to the `searchResult`
     * to furthest.
     */
    stores.features.sort((a, b) => {
      if (a.properties.distance > b.properties.distance) {
        return 1;
      }
      if (a.properties.distance < b.properties.distance) {
        return -1;
      }
      return 0; // a must be equal to b
    });

    /**
     * Rebuild the listings:
     * Remove the existing listings and build the location
     * list again using the newly sorted stores.
     */
    const listings = document.getElementById('listings');
    while (listings.firstChild) {
      listings.removeChild(listings.firstChild);
    }
    buildLocationList(stores);

    /* Open a popup for the closest store. */
    createPopUp(stores.features[0]);

    /** Highlight the listing for the closest store. */
    const activeListing = document.getElementById(
      `listing-${stores.features[0].properties.id}`
    );
    activeListing.classList.add('active');

    /**
     * Adjust the map camera:
     * Get a bbox that contains both the geocoder result and
     * the closest store. Fit the bounds to that bbox.
     */
    const bbox = getBbox(stores, 0, searchResult);
    map.fitBounds(bbox, {
      padding: 100
    });
  });
});

/**
 * Using the coordinates (lng, lat) for
 * (1) the search result and
 * (2) the closest store
 * construct a bbox that will contain both points
 */
function getBbox(sortedStores, storeIdentifier, searchResult) {
  const lats = [
    sortedStores.features[storeIdentifier].geometry.coordinates[1],
    searchResult.coordinates[1]
  ];
  const lons = [
    sortedStores.features[storeIdentifier].geometry.coordinates[0],
    searchResult.coordinates[0]
  ];
  const sortedLons = lons.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  const sortedLats = lats.sort((a, b) => {
    if (a > b) {
      return 1;
    }
    if (a.distance < b.distance) {
      return -1;
    }
    return 0;
  });
  return [
    [sortedLons[0], sortedLats[0]],
    [sortedLons[1], sortedLats[1]]
  ];
}

/**
 * Add a marker to the map for every store listing.
 **/
function addMarkers() {
  /* For each feature in the GeoJSON object above: */
  for (const marker of stores.features) {
    /* Create a div element for the marker. */
    const el = document.createElement('div');
    /* Assign a unique `id` to the marker. */
    el.id = `marker-${marker.properties.id}`;
    /* Assign the `marker` class to each marker for styling. */
    el.className = 'marker';

    /**
     * Create a marker using the div element
     * defined above and add it to the map.
     **/
    new mapboxgl.Marker(el, { offset: [0, -23] })
      .setLngLat(marker.geometry.coordinates)
      .addTo(map);

    /**
     * Listen to the element and when it is clicked, do three things:
     * 1. Fly to the point
     * 2. Close all other popups and display popup for clicked store
     * 3. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    el.addEventListener('click', (e) => {
      flyToStore(marker);
      createPopUp(marker);
      const activeItem = document.getElementsByClassName('active');
      e.stopPropagation();
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }
      const listing = document.getElementById(
        `listing-${marker.properties.id}`
      );
      listing.classList.add('active');
    });
  }
}

/**
 * Add a listing for each store to the sidebar.
 **/
function buildLocationList(stores) {
  for (const store of stores.features) {
    /* Add a new listing section to the sidebar. */
    const listings = document.getElementById('listings');
    const listing = listings.appendChild(document.createElement('div'));
    /* Assign a unique `id` to the listing. */
    listing.id = `listing-${store.properties.id}`;
    /* Assign the `item` class to each listing for styling. */
    listing.className = 'item';

    /* Add the link to the individual listing created above. */
    const link = listing.appendChild(document.createElement('a'));
    link.href = '#';
    link.className = 'title';
    link.id = `link-${store.properties.id}`;
    link.innerHTML = `${store.properties.name}`;

    /* Add details to the individual listing. */
    const details = listing.appendChild(document.createElement('div'));
    details.innerHTML = `${store.properties.address}<br/> ${store.properties.city}, ${store.properties.state} ${store.properties.postalCode}<br/>`;
    if (store.properties.phone) {
      details.innerHTML += `<strong>Phone:</strong> <a href="tel:+1${store.properties.phoneFormatted}">${store.properties.phoneFormatted}</a>`;
    }
    if (store.properties.distance) {
      const roundedDistance =
        Math.round(store.properties.distance * 160) / 100;
      details.innerHTML += `<div><strong>${roundedDistance} km away</strong></div>`;
    }

    /**
     * Listen to the element and when it is clicked, do four things:
     * 1. Update the `currentFeature` to the store associated with the clicked link
     * 2. Fly to the point
     * 3. Close all other popups and display popup for clicked store
     * 4. Highlight listing in sidebar (and remove highlight for all other listings)
     **/
    link.addEventListener('click', function () {
      for (const feature of stores.features) {
        if (this.id === `link-${feature.properties.id}`) {
          flyToStore(feature);
          createPopUp(feature);
        }
      }
      const activeItem = document.getElementsByClassName('active');
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }
      this.parentNode.classList.add('active');
    });
  }
}

/**
 * Use Mapbox GL JS's `flyTo` to move the camera smoothly
 * a given center point.
 **/
function flyToStore(currentFeature) {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 15
  });
}

/**
 * Create a Mapbox GL JS `Popup`.
 **/
function createPopUp(currentFeature) {
  const popUps = document.getElementsByClassName('mapboxgl-popup');
  if (popUps[0]) popUps[0].remove();

  const popup = new mapboxgl.Popup({ closeOnClick: false })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      `<h3>${currentFeature.properties.name}</h3><p>${currentFeature.properties.address}<br/>${currentFeature.properties.city},${currentFeature.properties.state} ${currentFeature.properties.postalCode}<br/><strong>Phone:</strong> ${currentFeature.properties.phone}</p>`
    )
    .addTo(map);
}

$(document).click(function() {
    var container = $(".mapboxgl-popup");
    if (!container.is(event.target) && !container.has(event.target).length) {
        container.hide();
    }
});